import { api } from "roboflex-thalamus-request-handler";
import { sso } from "roboflex-thalamus-sso-lib";

export class NotificationService {
  constructor(buildMode) {
    this.buildMode = buildMode;
  }

  /**
   * @param {{ page?: number, perPage?: number }} [params]
   * @returns {Promise<{ data: Array, meta: { current_page: number, per_page: number, total: number, last_page: number, has_more: boolean } }>}
   */
  async getNotificacoes({ page = 1, perPage = 5 } = {}) {
    const usuarioLogado = await sso.getUsuarioLogado();
    try {
      const response = await api.get(`notificacoes/usuario/${usuarioLogado.id}`, {
        params: { page, per_page: perPage },
      });
      const body = response.data;
      if (Array.isArray(body)) {
        return {
          data: body,
          meta: {
            current_page: 1,
            per_page: body.length,
            total: body.length,
            last_page: 1,
            has_more: false,
          },
        };
      }
      return {
        data: Array.isArray(body?.data) ? body.data : [],
        meta: {
          current_page: Number(body?.meta?.current_page) || page,
          per_page: Number(body?.meta?.per_page) || perPage,
          total: Number(body?.meta?.total) || 0,
          last_page: Number(body?.meta?.last_page) || 1,
          has_more: Boolean(body?.meta?.has_more),
        },
      };
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async lerNotificacao(ids) {
    try {
      return await api.post("notificacoes/ler", { notificacao: ids });
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async apagarNotificacoes(ids) {
    try {
      return await api.post("notificacoes/excluir", { notificacao: ids });
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}
